
  <template>
    <div> 
      <GenericBoard />
    </div>
  </template>
  
  <script>
  import GenericBoard from '@/views/QABoard/QAList.vue'
  
  export default {
    components: {
      GenericBoard
    }, 
  }
  </script>